import { render, staticRenderFns } from "./MessagesListItem.vue?vue&type=template&id=1a4f8174&"
import script from "./MessagesListItem.vue?vue&type=script&lang=js&"
export * from "./MessagesListItem.vue?vue&type=script&lang=js&"
import style0 from "./MessagesListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports